export const authSelector = state => ({
  errorMessage: state.auth.error.message,
  authStatus: state.auth.status,
  user: state.auth.user,
  redirect: state.auth.redirect,
});
